/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(a, b) {
  if (a && b) {
    return function () {
      a.apply(void 0, arguments);
      b.apply(void 0, arguments);
    };
  }
  return a || b;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/joinFunctions.js
// module id = 82
// module chunks = 0